import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MaterialButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './Button.scss';

const Button = ({
    onClick,
    children,
    className,
    isLoading,
    ...props
}) =>
    <MaterialButton
        className={classnames(styles.baseButton, className)}
        onClick={onClick}
        { ...props }
    >
        {
            isLoading ?
                <CircularProgress
                    size={24}
                    className={styles.isLoading}
                /> :
                children
        }
    </MaterialButton>;

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    isLoading: PropTypes.bool
};

Button.defaultProps = {
    className: '',
    isLoading: false
};

export default Button;

